<template>
  <div class="filters">
    <span v-if="title" class="filters__label">{{ title }}</span>
    <ul v-if="filters" class="filters__list list-inline">
      <li v-for="filter in filters" :key="filter.label" class="filters__list-item list-inline-item">
        <Button :styles="filterButtonStyles(filter.filterOn)" :onClick="handleFilterButtonClick(filter.filterOn)">
          <span slot="label"> {{ filter.label }}<i :class="filterButtonArrowStyles(filter.filterOn)"></i> </span>
        </Button>
      </li>
    </ul>
  </div>
</template>

<script>
import Button from "../button/Button";

export default {
  components: {
    Button
  },

  props: {
    title: {
      type: String
    },

    filters: {
      type: Array
    },

    currentFilter: {
      type: String
    },

    currentFilterOrder: {
      type: Object
    },

    onFilterButtonClick: {
      type: Function
    }
  },

  computed: {
    filterButtonStyles() {
      return filterOn => {
        return {
          "mr-2": true,
          "button--selected": filterOn === this.currentFilter
        };
      };
    },

    filterButtonArrowStyles() {
      return filterOn => {
        return {
          "ml-2": true,
          fa: true,
          "fa-long-arrow-up": this.currentFilterOrder[filterOn] === "DESC",
          "fa-long-arrow-down": this.currentFilterOrder[filterOn] === "ASC"
        };
      };
    }
  },

  methods: {
    handleFilterButtonClick(filterOn) {
      return event => {
        if (this.onFilterButtonClick !== undefined) {
          this.onFilterButtonClick(event, filterOn);
        }
      };
    }
  }
};
</script>
